import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { listStyles } from './commons/listStyles';
export var Ol = styled.ol.withConfig({
  displayName: "OrderedList__Ol",
  componentId: "sc-1b9mada-0"
})(["counter-reset:ol;"]);
export var OrderedList = styled.li.withConfig({
  displayName: "OrderedList",
  componentId: "sc-1b9mada-1"
})(["", ";&:before{left:-15px;width:36px;content:counter(ol) '. ';counter-increment:ol;", ";}"], listStyles, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      left: 12px;\n    "]))));